
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"a","data-v-5a7574ec":""}},[_c('path',{staticStyle:{"fill":"#d20311"},attrs:{"d":"M47.19,0h-30.36C7.54,0,0,6.2,0,13.84v35.64c0,8.02,7.9,14.52,17.66,14.52h29.53c9.29,0,16.83-6.18,16.81-13.82V13.82c0-7.64-7.52-13.82-16.81-13.82ZM21.03,52.04h-8.28v-26.72h8.28v26.72ZM16.85,21.82c-2.7,0-4.89-2.21-4.89-4.93s2.19-4.93,4.89-4.93,4.89,2.21,4.89,4.93-2.19,4.93-4.89,4.93ZM52.04,52.04h-8.23v-14.03c0-3.85-1.46-5.99-4.5-5.99-3.31,0-5.04,2.24-5.04,5.99v14.03h-7.94v-26.72h7.94v3.6s2.39-4.42,8.06-4.42,9.72,3.46,9.72,10.62v16.92Z"}})])])
          )
        }
      }
    